export default {
  appTitle: 'Arcaea - New Dimension Rhythm Game',
  appDescription: 'A harmony of Light awaits you in a lost world of musical Conflict. New Dimension Rhythm Game.',
  hrefLang: 'en',
  fbLang: 'en_US',
  switchTitle: 'Arcaea for Nintendo Switch',
  confirm: 'Confirm',
  cancel: 'Cancel',
  inMaintenance: 'Under maintenance.<br/>Please try again in a few hours.',
  menu: {
    songRanking: 'SONG RANKING',
    story: 'STORY',
    goods: 'GOODS',
    login: 'Log in',
    account: 'My Account'
  },
  footer: {
    copyright: '© 2021 lowiro',
    contact: 'Contact',
    terms: 'Terms of Service',
    derivativeWorks: 'Derivative Works Guidelines',
    privacyPolicy: 'Privacy Policy',
    streamingGuidelines: 'Streaming Guidelines'
  },
  homepage: {
    artist: 'Artist',
    artwork: 'Illustration',
    songDescription: 'A random selection of songs playable in Arcaea',
    availableOnAndroid: '可通过安卓系统下载', // Special for zh
    arcaeaSwitch: 'Arcaea Nintendo Switch™'
  },
  account: {
    login: 'Log in',
    logout: 'Log out',
    errorLogin: 'Could not log in. Please check your credentials.',
    username: 'USERNAME',
    checking: 'Checking...',
    changeUsername: 'Change username',
    nameUnavailable: 'Name already in use. Please choose another name.',
    nameInvalid: 'Username must be 3-15 characters a-Z 0-9',
    email: 'EMAIL',
    changeEmail: 'Change email',
    errorEmailUnavailable: 'Email address already in use. Please use a different email address.',
    memories: 'MEMORIES',
    buyMore: 'PURCHASE',
    passwordReset: 'Password Reset',
    enterEmail: 'Please enter your registered email address',
    submit: 'SUBMIT',
    usernameEmailID: 'Username, Email, or User ID',
    forgotPassword: 'Forgot password?',
    errorInvalidEmail: 'Please enter a valid email address',
    errorUnknownEmail: 'No account is registered for this email address',
    requestForgotSuccess: 'Please check your email inbox for a link to reset your password.',
    newPassword: 'Please enter your new password',
    newPasswordConfirm: 'Confirm New Password',
    passwordResetInput: 'New password',
    passwordResetConfirm: 'Confirm new password',
    passwordResetSuccess: 'Password successfully changed',
    errorMismatchPassword: 'Entered passwords do not match',
    errorInvalidPassword: 'Password must be at least 8 characters in length',
    errorInvalidResetToken: 'Password reset expired. Please request a new reset link.',
    password: 'Password',
    loginCaps: 'LOG IN',
    creditCard: 'Credit Card',
    purchaseMemories: 'Purchase Memories',
    wouldLikePurchase: 'Purchase <br class="mobile-only"><span class="bold">{amount} Memories?</span>',
    nameChangeWarn: '<span class="bold highlight-color">{amount} Memories</span> will be charged for changing your name.<br/>Would you like to proceed?',
    payUsing: 'Payment Method',
    proccessingPayment: 'Processing',
    purchase: 'PURCHASE',
    purchaseFailed: 'Purchase failed',
    purchaseFailedDescription: 'Your purchase couldn\'t be completed.<br/>Please try again.',
    purchaseComplete: 'Purchase complete',
    justAdded: 'You completed a purchase of {amount} Memories.',
    thankYou: 'Thank you for your purchase!',
    Account: 'Account', // "Account" as in User Account
    backToAccount: 'Back to Account',
    currentMemories: 'CURRENT MEMORIES',
    usernameCost: 'Changing your username will cost you <span class="bold">{amount} Memories</span>.',
    change: 'Change',
    cancel: 'Cancel',
    newName: 'Your new name',
    newNameConfirm: 'Your username will be changed to:',
    newEmailConfirm: 'Your e-mail will be changed to:',
    newEmail: 'New email address',
    emailChangeWarn: 'Are you sure you want to change your email address to <b>{email}</b>?',
    checkInbox: 'Please check your email inbox for a link to verify your changes.',
    verifyingEmail: 'Verifying...',
    verifyEmailSuccess: 'Email address successfully changed.',
    errorVerifyEmail: 'Email address change failed. Please retry from the beginning.',
    confirmPaymentChina: `By using this payment service, I agree that I am residing within the People's Republic of China.<br/>Usage of this payment service outside of the PRC may result in your account being restricted.`,
    agree: 'Agree',
    version: 'Version {version}',
    deleteUser: 'Account Deletion Request Confirmation',
    verifyDeleteUserSuccess: 'Your Arcaea account has been successfully deleted.',
    errorVerifyDeleteUser: 'Account deletion failed. Please restart the process.',
    verifyingDeleteUser: 'Verifying...',
    selectYourRegion: 'Select Region',
    ensureSelectRegion: 'To purchase Memories online your region must match the region associated with your preferred payment method.',
    selectRegionConfirm: 'Selected Region'
  },
  goods: {
    originalSoundtracks: 'Original Soundtracks',
    diverseDirect: 'DIVERSE DIRECT',
    tanoc: 'TANO*C STORE',
    amazon: 'Amazon.co.jp',
    lineHeader: 'Arcaea Official LINE Stickers',
    lineText1: 'Make your conversations more memorable with these cute and colorful official LINE stickers of your favorite Arcaea characters!',
    lineButton: 'Go to LINE Store!'
  },
  songRanking: {
    freeMusic: 'Free Music',
    paidMusic: 'Paid Music',
    title: 'Title',
    artist: 'Artist',
    new: 'New'
  },
  purchase: {
    sorryNotSupported: 'Sorry, purchases from your region are currently not supported on the Arcaea site',
    memoryWithBonus: '{amount} + Bonus ({bonusAmount})',
    priceCurrencyFront: '{currency}{amount}',
    priceCurrencyBack: '{amount}{currency}'
  },
  contact: {
    header: 'Questions, Support & Press'
  },
  story: {
    slide1: {
      text: `Two young girls explore a shattered world, filled with sound: a past to be uncovered...<br/>
<br/>
Each awakens in this blank, ruin-dotted world to discover that she is equally blank, remembering nothing of what came before.<br/>
And then they make a second discovery: the Arcaea, multitudes of floating glass-like shards containing vivid memories of the past.<br/>`,
    },
    slide2: {
      text: `These shards gather to each girl, as though each is choosing who to be experienced by.<br/>
And each girl, in turn, experiences different memories, each in her own way.<br/>
<br/>
<i>The glass reflected another world than the one in white surrounding her. In it she could see reflections of seas, cities, fires, lights; she rose her hand to scatter them, and laughed in joy.</i><br/>
<br/>
<i>She could see glimpses of something else in them, like looking through the windows of a train car. In one flash she saw rain, in another sunlight, and in another death. She grimaced, and pulled away</i>.<br/>
      `
    },
    slide3: {
      text: `Two young girls, exploring a shattered world, uncovering the past.<br/>
<br/>
One of Light, the other of Conflict.<br/>
<br/>
How will their exploration of this world of Arcaea shape them?<br/>
<br/>
<i>A pleasant, simple world like this need only be pleasant. Nothing more.</i><br/>
<br/>
<i>Wherever it is these shards reflect... she sees little light there. Whatever small sparks she sees fade away in an instant.</i><br/>
<br/>
And, at the end of their journeys, who will they have become?
`,
    }
  },
  links: {
    facebook: 'https://www.facebook.com/arcaeagame',
    twitter: 'https://twitter.com/arcaea_en',
    line: 'https://line.me/R/ti/p/%40sfc8511n',
    lineSticker: 'https://store.line.me/stickershop/product/7580603/en',
    bilibili: 'https://space.bilibili.com/404145357',
  },

  text: {
    termsOfService: `<p><b>Last updated:</b> January 14, 2020</p>

<p>These Terms of Service define the relationship between you and lowiro limited regarding your use of Arcaea, Arcaea online services, and the Arcaea official website.</p>
<p>By creating an Arcaea account, using the Arcaea services, or using the Arcaea official website, you signify your agreement to the Terms. If you do not agree to these Terms, you may not use the Services.</p>
<p>You can access these Terms at any time at <a href="https://arcaea.lowiro.com/terms_of_service">https://arcaea.lowiro.com/terms_of_service</a>. We reserve the right to change, modify, add, or remove portions of our Terms and Privacy Policy by posting the amended rules at <a href="https://arcaea.lowiro.com/terms_of_service">https://arcaea.lowiro.com/terms_of_service</a>. Your continued use of our Services confirms your acceptance of the updated Terms and Privacy Policy.</p>

<b>1. Definitions</b>
In order to make these Terms of Service clearer, we use shortened terminology to express certain concepts.
    ● <b>Account</b> refers to the user’s account in the game.
    ● <b>Memories</b> refers to Arcaea’s in-game currency, purchasable with legal currency.
    ● <b>Services</b> refers collectively to the Arcaea app (on all platforms), the Arcaea online services, and the Arcaea official website.
    ● <b>Terms</b> refers collectively to all terms and conditions in these Terms of Service.
    ● <b>We/us/our</b> refers to lowiro limited.
    ● <b>You/your</b> refers to you, the user!

<b>2. Account Creation</b>
    <b>2.1</b>   In order to purchase Memories, add friends, or upload your high scores to the online leaderboards, you are required to register for an Account.
    <b>2.2</b>   You must be connected to the Internet in order to register for and use an Account.
    <b>2.3</b>   You may only register one (1) Account.
    <b>2.4</b>   By registering for an Account, or by using our Services in any capacity, you represent that you are at least 13 years old and that you understand and agree to these Terms.

<b>3. License and Usage Restrictions</b>
    <b>3.1</b>   Subject to your compliance with these Terms, we grant you a non-exclusive, non-transferable license to use our Services for your own non-commercial entertainment purposes. You agree not to use our Services for any other purpose.
    <b>3.2</b>   You also agree not to do any of the following:
        1. modify the App in any way;
        2. share your Account with any third parties, such as friends or coworkers;
        3. be in possession of multiple Accounts simultaneously;
        4. reverse engineer, decompile, or disassemble the App;
        5. gather any information via “datamining,” that is, via examining the Services’ internal assets and code;
        6. collect any information through “harvesting” or “scraping” about the service or regarding any user, including yourself, who uses the Services;
        7. distribute, transfer, sublicense, lease, lend, or rent the App to any third party;
        8. make the functionality of the App available to multiple users through any means;
        9. use the Arcaea app or the Arcaea website for fraudulent or abusive purposes, including but not limited to using them to impersonate any person or entity, or otherwise;
        10. misrepresent our affiliation with a person, entity, or our Services;
        11. interfere with or disrupt the Services or servers or networks that provide the Services;
        12. disobey any requirements or regulations of any network connected to the Services;
        13. or circumvent technological measures designed to control access to, or elements of, the Services.
    <b>3.3</b>   lowiro reserves all rights in and to the App not expressly granted to you under these Terms.

<b>4. Derivative Works Policy</b>
For guidelines regarding usage of Arcaea in derivative works, please refer to the <a href="https://arcaea.lowiro.com/derivative_policy">Derivative Works Guidelines</a>. Your agreement to these Terms of Service also constitute an agreement to those guidelines.

<b>5. In-App Purchases and Billing</b>
    <b>5.1</b>   Our Services include Memories, a form of in-game currency. Memories can be purchased using legal currency and are used to purchase additional content in-game.
    <b>5.2</b>   You agree that Memories exist only within our Services and can not be exchanged for real money, real goods, or real services from us or anyone else.
    <b>5.3</b>   We reserve the right to control, regulate, change, or remove any Memories without any liability to you.
    <b>5.4</b>   All purchases of Memories are final and non-refundable, except as required by applicable law. By purchasing Memories, you confirm that you have the authority to use the payment method you selected and that such payment method has sufficient credit or funds available to complete your purchase.
    <b>5.5</b>   You may not refund any received in-game content through outside means such as Google Play without express permission from lowiro. This may lead to the removal of this content from your Account or closing of your Account.
    <b>5.6</b>   If any purchase of Memories has failed to appear in your Account, you must notify us by emailing us at <a href="mailto:contact@lowiro.com">contact@lowiro.com</a>.
    <b>5.7</b>   Should we close your Account, you will lose any Memories that you may possess, and we will not compensate you for this loss or make any refund to you.

<b>6. Termination of Account</b>
    <b>6.1</b>   Should your Account be found to be engaging in any of the activities in section 3, we reserve the right to terminate your Account.
    <b>6.2</b>   We reserve the right to terminate your Account for any activities that would infringe on any law, including but not limited to copyright law.
    <b>6.3</b>   We reserve the right to terminate your Account should you engage in threats or harassment against lowiro, its Services, or its staff.
    <b>6.4</b>   We also reserve the right to terminate your Account for other activities deemed to harm the spirit of fair play not listed in these Terms.

<b>7. Privacy</b>
Please refer to our <a href="https://arcaea.lowiro.com/privacy_policy">Privacy Policy</a> for information on how we handle personal information from our users.

<b>8. Limitation of Liability</b>
    <b>8.1</b>   We are not liable to you for any damages, whether physical, digital, or monetary, that may occur during gameplay or usage of the Services.
    <b>8.2</b>   As stated in section 4.4, all Memories are non-refundable and will not be compensated for in the event that you lose them for whatever reason.

<b>9. Updates to Arcaea</b>
    <b>9.1</b>   As Arcaea is a continuously evolving game, we will occasionally update the game. These updates will include, but are not limited to, gameplay mechanics, visual design, character (“Partner”) availability and song availability.
    <b>9.2</b>   We reserve the right to make changes to these Terms at any time and for any reason. You acknowledge that it is your responsibility to check the Terms for updates periodically.

<b>10. Governing Law</b>
These Terms are governed by the laws in the United Kingdom of Great Britain and Northern Ireland. All disputes will be settled in the United Kingdom.

<b>11. Contact Information</b>
If you’d like to report a bug or a payment failure, please email <a href="mailto:contact@lowiro.com">contact@lowiro.com</a> with a clear explanation of the issue, your in-game username and ID, and, if possible, screenshots depicting the issue. For all other inquiries, such as advertising and PR, please email <a href="mailto:contact@lowiro.com">contact@lowiro.com.<a/>`,

    derivativePolicy: `<p><b>Last updated:</b> January 30, 2020</p>
<p>Here at lowiro, we are more than happy to see fans of Arcaea using its characters and world in their own original works. Please refer to these guidelines for any questions about what is and isn’t permissible in derivative works.</p>
<p>Your agreement to the Terms of Service constitutes an agreement to these guidelines as well.</p>
<b>1. What You Can and Can’t Use</b>

<p>The general rule is that you may not use any assets or materials released by lowiro or copyrighted by lowiro in either digital or physical form. This includes, but is not limited to, anything released in the Arcaea app, the online service, any official channels such as Arcaea’s Twitter accounts and Discord, and any official physical or digital merchandise.</p>
<p>These guidelines grant you permission to use characters, settings, story, and other contents included with Arcaea’s Main Story and Side Story for derivative works. While some other characters and settings, such as certain events, are governed by the same guidelines, other content may require permission from other copyright holders, such as collaborations. These guidelines do not cover such content, and you may have to check for permission from the respective copyright holders before using them.</p>
<p><u>Artwork</u>: You may not copy or use any game assets, including but not limited to character and event graphics, for use in your own works. This includes both digital assets and physical ones, eg. designs and artwork from official CDs. However, you may create your own artwork based on the game if you wish, as long as you’re not tracing any of the aforementioned assets.</p>
<p><u>Music</u>: You may not use any of the music or sound effects included in the Arcaea app or on any of its official soundtracks for any purpose, including derivative works. This includes fanmade charts and levels for rhythm games.</p>
<p><u>Story</u>: You may not copy any of the written story text in Arcaea for use in derivative works. However, you may use the story itself as a basis for your own works, such as in novels or comics.</p><ul><li><u>Translations</u>: If you’d like to write a translation of Arcaea’s story in a currently unsupported language, please get in touch with us at <a href="mailto:contact@lowiro.com">contact@lowiro.com</a> describing how you plan on using it.</li></ul>
<p><u>Logo</u>: You may not use the Arcaea logo, the lowiro logo, or any images closely resembling them for any purpose, including derivative works.</p>
<b>2. What You Can Use It For</b>

<p>lowiro expressly forbids any elements of Arcaea to be included in the following types of derivative works:</p><ul><li>Games (physical or digital)</li><li>Software</li><li>Commercial works/merchandise (physical or digital)</li></ul>
<p>Other types of works, such as fanart, novels, and comics, whether physical or digital, are permitted, as long as they follow all the rules stated in these Guidelines.</p>
<b>3. Disclaimer</b>
<p>These guidelines do not release any copyrighted contents to the public domain, nor do these guidelines change the copyright status of copyrighted contents. lowiro reserves the right to disallow any derivative use or withdraw these permissions at its discretion. It also reserves the right to modify these guidelines at any time without notice. Please make sure to check the latest version of these guidelines before creating any derivative works.</p>`,

    privacyPolicy: `<p><b>Last updated:</b> August 26, 2019</p>
<p>Arcaea was built by lowiro limited as a freemium app and online website service. The app, website, and all web services are collectively referred to as the “Service.” The Service is provided by lowiro limited at no cost. It is intended for use as-is.</p>
<p>This Privacy Policy (“Policy”) aims to inform visitors to and users of our Service of our policies regarding the collection, use, and disclosure of your personal information. Choosing to use our Service constitutes an agreement to this Privacy Policy, including what information we collect and how we use it.</p>
<p>Information that we collect about you is only used for providing and improving our Service. We will not use or share your information with anyone except as described in this Policy.</p>

<b>Information Collection and Use</b>
<p>For a better experience, we may require you to provide us with certain personally identifiable information while using our Service. This information includes, but is not limited to, your email address. We will retain any requested information and use it only as described in this Policy.</p>
<p>Unless you specifically request us to, we will not send any emails, marketing or otherwise, to the email address you’ve provided to us.</p>
<p>The app does use third-party services that may collect information used to identify you. Here is a link to the privacy policy of each of the third-party service providers we use:</p>
• <a target="_blank" href="https://www.google.com/policies/privacy/">Google Play Services</a>
• <a target="_blank" href="https://firebase.google.com/policies/analytics/">Firebase Analytics</a>
• <a target="_blank" href="https://fabric.io/privacy">Fabric</a>
• <a target="_blank" href="http://try.crashlytics.com/terms/privacy-policy.pdf">Crashlytics</a>

<b>Log Data</b>
<p>When using our Service, should an error ever occur, we will collect data and information from your device (through the third party products listed above) which we call “log data.” This log data may include information such as your device’s Internet Protocol (or “IP”) address, its model, its operating system version, the app’s current configuration, the time and date you were playing, and other statistics.</p>

<b>Cookies</b>
<p>Cookies are files containing small amounts of data. They are commonly used to identify users while protecting the user’s anonymity. Websites you visit will send cookies to your browser, and these cookies are then stored on your device’s internal memory.</p>
<p>Arcaea uses cookies to allow you to log into the Service. It may also use third party code and libraries that use cookies to collect information and improve their services. You have the option to accept or refuse these cookies and to know when a cookie is being sent to your device. If you choose not to accept cookies from us, you may not be able to use some portions of the Service.</p>

<b>Service Providers</b>
<p>We may employ third-party companies and individuals for the following reasons:</p>
• to facilitate our Service;
• to provide the Service on our behalf;
• to perform Service-related services; or
• to assist us in analyzing how our Service is used.

<p>These third parties will have access to the personal information of anyone who uses our Service. This is so they can perform the tasks we have assigned to them. They are obligated not to disclose or use this information for any other purpose.</p>

<b>Security</b>
<p>Personal data is stored securely using modern software practices and is only accessible to those who need access when related to the development of the service. Disaster-prevention and recovery solutions are also in place.</p>
<p>However, no form of data transmission over the Internet or method of electronic storage is 100% secure. By using our Service, you agree to send this information to us at your own risk. If you believe your personal data has been compromised, please contact us at the email address at the bottom of this Policy.</p>

<b>Retention and Erasure</b>
<p>Personal data is retained for as long as the Service is available. We do this so that you can recover your account and return to the service at any time in the future.</p>
<p>You may request erasure of your personal data from our systems. To do this, we will need to verify via email using the registered address. This process is irreversible once performed, and you will no longer be able to use the Service after doing this.</p>

<b>Links to Other Sites</b>
<p>This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

<b>Children’s Privacy</b>
<p>Our Service is not directed to children under the age of 13. We do not knowingly collect personally identifiable information from children under 13. If we discover that a child under 13 has provided us with personal information, we will immediately delete it from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us at the email address at the bottom of the Policy so that we can take necessary measures.</p>

<b>Changes to This Privacy Policy</b>
<p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.</p>

<b>Contact Us</b>
<p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at <a href="mailto:contact@lowiro.com">contact@lowiro.com</a>.</p>`,

    streamingGuidelines: `<p><b>Last updated:</b> July 9, 2021</p>

<p>We here at lowiro are delighted that you would like to make your own original content based on Arcaea! Our fans, including content creators, are a big reason for our success. To ensure a positive contribution to the community and fanbase via a video or streaming site, such as YouTube or Twitch, we ask that you please read, understand, and follow the guidelines set forth below.</p>
<b>1. General Guidelines</b>
<ul><li>We allow players to create and stream content that is instructional or shows reactions, commentary, reviews, or live game play. We encourage the commentary to be related to the game play being shown.</li><li>We allow uploading to any website that allows streaming or video uploads, including your own.</li><li>Fan content, or any other content not released in an official format by lowiro, may not be promoted as official lowiro content.</li><li>Please be mindful of any story or gameplay-related spoilers in your stream or content. Many players may wish not to be spoiled before seeing something for themselves, so we recommend clearly marking spoilers beforehand where needed. Ultimately, however, this is down to your own judgement.</li><li>Any posting or otherwise unauthorized disclosure of content that has not yet been publicly announced is strictly forbidden.</li><li>You may not distribute, in video form or otherwise, assets from the game that have been removed from actual gameplay. Any video or other created content may only use Arcaea gameplay as a whole, with both video and sound footage included. The sound and video may not be used separately, and ALL content must be used in conjunction with gameplay.</li><li>In the same vein, the content you make should be original in some way. Videos that are purely duplications of officially released content, such as trailers or previews, are forbidden.</li><li>All collaboration content in Arcaea (marked in the “Collaboration Pack” section) is excluded from these permissions and you will need to obtain permission from appropriate rights holders.</li><li>We encourage the streaming of most songs in the Main Story and Side Story packs, with certain exceptions. While we strive to provide these guidelines so that creators can understand our endorsement of streaming Arcaea, please understand that we cannot provide an exhaustive list of permitted songs, and that you stream at your own discretion in regard to the right held by parties other than lowiro.</li><li>We cannot take responsibility for any Content ID claims that may arise from the usage of songs from other rights holders. Please handle these at your own discretion.</li><li>Confirming song rights and streaming rights are the responsibility of the streamer or video creator. Please understand that the guidance above is all we can provide, and that certain songs may be subject to further restrictions.</li></ul><b>2. Commercialization Guidelines</b>
<ul><li>We do not allow any commercial use of content in Arcaea without prior permission.</li><li>The exception is if you are an individual monetizing through partner programs or advertising from streaming sites and/or collecting the types of voluntary contributions listed below, as long as the video itself is available for free and you are not monetizing on behalf of a non-individual entity. The allowed voluntary contributions are: SuperChat (YouTube), Bits (Twitch), and tipping (Facebook).</li><li>If you wish to monetize on behalf of a non-individual entity, or are otherwise part of a non-individual entity, please contact us at <a href="mailto:contact@lowiro.com">contact@lowiro.com</a> to obtain permission.</li></ul><b>3. Impermissible Uses</b>
<ul><li>We do not allow inappropriate content in Arcaea-related videos. This includes age-restricted content as well as any content that is illegal, is prejudiced in any way (including racist, sexist, or disparaging content), or is otherwise offensive. We reserve the right to take down such content.</li><li>We do not allow Arcaea-related videos to contain any unreleased content or “leaks”, and we reserve the right to take down such content.</li></ul><b>4. Other Rules</b>
<ul><li>This policy only applies to Arcaea and lowiro content. If your video or stream includes content from elsewhere, you may need to familiarize yourself with their policies on video content as well.</li><li>Failure to abide by these rules and guidelines regarding video and streaming content may result in lowiro taking action to have such content removed. lowiro reserves the right to change these policies, at any time for any reason, without informing you. Please ensure that you check this policy first when creating Arcaea-related content.</li><li>This policy is not exhaustive, and we reserve the right to remove any objectionable content that does not fit into the guidelines set forth in it.</li><li>For more information and guidelines on derivative works, please check the following link: <a href="https://arcaea.lowiro.com/derivative_policy">https://arcaea.lowiro.com/derivative_policy</a></li></ul>`
  },
  countries: [
    { "id": 4, "name": "Afghanistan", "a2": "af" },
    { "id": 248, "name": "Åland Islands", "a2": "ax" },
    { "id": 8, "name": "Albania", "a2": "al" },
    { "id": 12, "name": "Algeria", "a2": "dz" },
    { "id": 16, "name": "American Samoa", "a2": "as" },
    { "id": 20, "name": "Andorra", "a2": "ad" },
    { "id": 24, "name": "Angola", "a2": "ao" },
    { "id": 660, "name": "Anguilla", "a2": "ai" },
    { "id": 10, "name": "Antarctica", "a2": "aq" },
    { "id": 28, "name": "Antigua and Barbuda", "a2": "ag" },
    { "id": 32, "name": "Argentina", "a2": "ar" },
    { "id": 51, "name": "Armenia", "a2": "am" },
    { "id": 533, "name": "Aruba", "a2": "aw" },
    { "id": 36, "name": "Australia", "a2": "au" },
    { "id": 40, "name": "Austria", "a2": "at" },
    { "id": 31, "name": "Azerbaijan", "a2": "az" },
    { "id": 44, "name": "Bahamas", "a2": "bs" },
    { "id": 48, "name": "Bahrain", "a2": "bh" },
    { "id": 50, "name": "Bangladesh", "a2": "bd" },
    { "id": 52, "name": "Barbados", "a2": "bb" },
    { "id": 112, "name": "Belarus", "a2": "by" },
    { "id": 56, "name": "Belgium", "a2": "be" },
    { "id": 84, "name": "Belize", "a2": "bz" },
    { "id": 204, "name": "Benin", "a2": "bj" },
    { "id": 60, "name": "Bermuda", "a2": "bm" },
    { "id": 64, "name": "Bhutan", "a2": "bt" },
    { "id": 68, "name": "Bolivia (Plurinational State of)", "a2": "bo" },
    { "id": 535, "name": "Bonaire, Sint Eustatius and Saba", "a2": "bq" },
    { "id": 70, "name": "Bosnia and Herzegovina", "a2": "ba" },
    { "id": 72, "name": "Botswana", "a2": "bw" },
    { "id": 74, "name": "Bouvet Island", "a2": "bv" },
    { "id": 76, "name": "Brazil", "a2": "br" },
    { "id": 86, "name": "British Indian Ocean Territory", "a2": "io" },
    { "id": 96, "name": "Brunei Darussalam", "a2": "bn" },
    { "id": 100, "name": "Bulgaria", "a2": "bg" },
    { "id": 854, "name": "Burkina Faso", "a2": "bf" },
    { "id": 108, "name": "Burundi", "a2": "bi" },
    { "id": 132, "name": "Cabo Verde", "a2": "cv" },
    { "id": 116, "name": "Cambodia", "a2": "kh" },
    { "id": 120, "name": "Cameroon", "a2": "cm" },
    { "id": 124, "name": "Canada", "a2": "ca" },
    { "id": 136, "name": "Cayman Islands", "a2": "ky" },
    { "id": 140, "name": "Central African Republic", "a2": "cf" },
    { "id": 148, "name": "Chad", "a2": "td" },
    { "id": 152, "name": "Chile", "a2": "cl" },
    { "id": 156, "name": "China Mainland", "a2": "cn" },
    { "id": 162, "name": "Christmas Island", "a2": "cx" },
    { "id": 166, "name": "Cocos (Keeling) Islands", "a2": "cc" },
    { "id": 170, "name": "Colombia", "a2": "co" },
    { "id": 174, "name": "Comoros", "a2": "km" },
    { "id": 178, "name": "Congo, Republic of", "a2": "cg" },
    { "id": 180, "name": "Congo, Democratic Republic of", "a2": "cd" },
    { "id": 184, "name": "Cook Islands", "a2": "ck" },
    { "id": 188, "name": "Costa Rica", "a2": "cr" },
    { "id": 384, "name": "Côte d'Ivoire", "a2": "ci" },
    { "id": 191, "name": "Croatia", "a2": "hr" },
    { "id": 192, "name": "Cuba", "a2": "cu" },
    { "id": 531, "name": "Curaçao", "a2": "cw" },
    { "id": 196, "name": "Cyprus", "a2": "cy" },
    { "id": 203, "name": "Czechia", "a2": "cz" },
    { "id": 208, "name": "Denmark", "a2": "dk" },
    { "id": 262, "name": "Djibouti", "a2": "dj" },
    { "id": 212, "name": "Dominica", "a2": "dm" },
    { "id": 214, "name": "Dominican Republic", "a2": "do" },
    { "id": 218, "name": "Ecuador", "a2": "ec" },
    { "id": 818, "name": "Egypt", "a2": "eg" },
    { "id": 222, "name": "El Salvador", "a2": "sv" },
    { "id": 226, "name": "Equatorial Guinea", "a2": "gq" },
    { "id": 232, "name": "Eritrea", "a2": "er" },
    { "id": 233, "name": "Estonia", "a2": "ee" },
    { "id": 748, "name": "Eswatini", "a2": "sz" },
    { "id": 231, "name": "Ethiopia", "a2": "et" },
    { "id": 238, "name": "Falkland Islands (Malvinas)", "a2": "fk" },
    { "id": 234, "name": "Faroe Islands", "a2": "fo" },
    { "id": 242, "name": "Fiji", "a2": "fj" },
    { "id": 246, "name": "Finland", "a2": "fi" },
    { "id": 250, "name": "France", "a2": "fr" },
    { "id": 254, "name": "French Guiana", "a2": "gf" },
    { "id": 258, "name": "French Polynesia", "a2": "pf" },
    { "id": 260, "name": "French Southern Territories", "a2": "tf" },
    { "id": 266, "name": "Gabon", "a2": "ga" },
    { "id": 270, "name": "Gambia", "a2": "gm" },
    { "id": 268, "name": "Georgia", "a2": "ge" },
    { "id": 276, "name": "Germany", "a2": "de" },
    { "id": 288, "name": "Ghana", "a2": "gh" },
    { "id": 292, "name": "Gibraltar", "a2": "gi" },
    { "id": 300, "name": "Greece", "a2": "gr" },
    { "id": 304, "name": "Greenland", "a2": "gl" },
    { "id": 308, "name": "Grenada", "a2": "gd" },
    { "id": 312, "name": "Guadeloupe", "a2": "gp" },
    { "id": 316, "name": "Guam", "a2": "gu" },
    { "id": 320, "name": "Guatemala", "a2": "gt" },
    { "id": 831, "name": "Guernsey", "a2": "gg" },
    { "id": 324, "name": "Guinea", "a2": "gn" },
    { "id": 624, "name": "Guinea-Bissau", "a2": "gw" },
    { "id": 328, "name": "Guyana", "a2": "gy" },
    { "id": 332, "name": "Haiti", "a2": "ht" },
    { "id": 334, "name": "Heard Island and McDonald Islands", "a2": "hm" },
    { "id": 336, "name": "Holy See", "a2": "va" },
    { "id": 340, "name": "Honduras", "a2": "hn" },
    { "id": 344, "name": "Hong Kong", "a2": "hk" },
    { "id": 348, "name": "Hungary", "a2": "hu" },
    { "id": 352, "name": "Iceland", "a2": "is" },
    { "id": 356, "name": "India", "a2": "in" },
    { "id": 360, "name": "Indonesia", "a2": "id" },
    { "id": 364, "name": "Iran (Islamic Republic of)", "a2": "ir" },
    { "id": 368, "name": "Iraq", "a2": "iq" },
    { "id": 372, "name": "Ireland", "a2": "ie" },
    { "id": 833, "name": "Isle of Man", "a2": "im" },
    { "id": 376, "name": "Israel", "a2": "il" },
    { "id": 380, "name": "Italy", "a2": "it" },
    { "id": 388, "name": "Jamaica", "a2": "jm" },
    { "id": 392, "name": "Japan", "a2": "jp" },
    { "id": 832, "name": "Jersey", "a2": "je" },
    { "id": 400, "name": "Jordan", "a2": "jo" },
    { "id": 398, "name": "Kazakhstan", "a2": "kz" },
    { "id": 404, "name": "Kenya", "a2": "ke" },
    { "id": 296, "name": "Kiribati", "a2": "ki" },
    { "id": 408, "name": "Korea (Democratic People's Republic of)", "a2": "kp" },
    { "id": 410, "name": "Korea, Republic of", "a2": "kr" },
    { "id": 414, "name": "Kuwait", "a2": "kw" },
    { "id": 417, "name": "Kyrgyzstan", "a2": "kg" },
    { "id": 418, "name": "Lao People's Democratic Republic", "a2": "la" },
    { "id": 428, "name": "Latvia", "a2": "lv" },
    { "id": 422, "name": "Lebanon", "a2": "lb" },
    { "id": 426, "name": "Lesotho", "a2": "ls" },
    { "id": 430, "name": "Liberia", "a2": "lr" },
    { "id": 434, "name": "Libya", "a2": "ly" },
    { "id": 438, "name": "Liechtenstein", "a2": "li" },
    { "id": 440, "name": "Lithuania", "a2": "lt" },
    { "id": 442, "name": "Luxembourg", "a2": "lu" },
    { "id": 446, "name": "Macao", "a2": "mo" },
    { "id": 450, "name": "Madagascar", "a2": "mg" },
    { "id": 454, "name": "Malawi", "a2": "mw" },
    { "id": 458, "name": "Malaysia", "a2": "my" },
    { "id": 462, "name": "Maldives", "a2": "mv" },
    { "id": 466, "name": "Mali", "a2": "ml" },
    { "id": 470, "name": "Malta", "a2": "mt" },
    { "id": 584, "name": "Marshall Islands", "a2": "mh" },
    { "id": 474, "name": "Martinique", "a2": "mq" },
    { "id": 478, "name": "Mauritania", "a2": "mr" },
    { "id": 480, "name": "Mauritius", "a2": "mu" },
    { "id": 175, "name": "Mayotte", "a2": "yt" },
    { "id": 484, "name": "Mexico", "a2": "mx" },
    { "id": 583, "name": "Micronesia (Federated States of)", "a2": "fm" },
    { "id": 498, "name": "Moldova, Republic of", "a2": "md" },
    { "id": 492, "name": "Monaco", "a2": "mc" },
    { "id": 496, "name": "Mongolia", "a2": "mn" },
    { "id": 499, "name": "Montenegro", "a2": "me" },
    { "id": 500, "name": "Montserrat", "a2": "ms" },
    { "id": 504, "name": "Morocco", "a2": "ma" },
    { "id": 508, "name": "Mozambique", "a2": "mz" },
    { "id": 104, "name": "Myanmar", "a2": "mm" },
    { "id": 516, "name": "Namibia", "a2": "na" },
    { "id": 520, "name": "Nauru", "a2": "nr" },
    { "id": 524, "name": "Nepal", "a2": "np" },
    { "id": 528, "name": "Netherlands", "a2": "nl" },
    { "id": 540, "name": "New Caledonia", "a2": "nc" },
    { "id": 554, "name": "New Zealand", "a2": "nz" },
    { "id": 558, "name": "Nicaragua", "a2": "ni" },
    { "id": 562, "name": "Niger", "a2": "ne" },
    { "id": 566, "name": "Nigeria", "a2": "ng" },
    { "id": 570, "name": "Niue", "a2": "nu" },
    { "id": 574, "name": "Norfolk Island", "a2": "nf" },
    { "id": 807, "name": "North Macedonia", "a2": "mk" },
    { "id": 580, "name": "Northern Mariana Islands", "a2": "mp" },
    { "id": 578, "name": "Norway", "a2": "no" },
    { "id": 512, "name": "Oman", "a2": "om" },
    { "id": 586, "name": "Pakistan", "a2": "pk" },
    { "id": 585, "name": "Palau", "a2": "pw" },
    { "id": 275, "name": "Palestine, State of", "a2": "ps" },
    { "id": 591, "name": "Panama", "a2": "pa" },
    { "id": 598, "name": "Papua New Guinea", "a2": "pg" },
    { "id": 600, "name": "Paraguay", "a2": "py" },
    { "id": 604, "name": "Peru", "a2": "pe" },
    { "id": 608, "name": "Philippines", "a2": "ph" },
    { "id": 612, "name": "Pitcairn", "a2": "pn" },
    { "id": 616, "name": "Poland", "a2": "pl" },
    { "id": 620, "name": "Portugal", "a2": "pt" },
    { "id": 630, "name": "Puerto Rico", "a2": "pr" },
    { "id": 634, "name": "Qatar", "a2": "qa" },
    { "id": 638, "name": "Réunion", "a2": "re" },
    { "id": 642, "name": "Romania", "a2": "ro" },
    { "id": 643, "name": "Russian Federation", "a2": "ru" },
    { "id": 646, "name": "Rwanda", "a2": "rw" },
    { "id": 652, "name": "Saint Barthélemy", "a2": "bl" },
    { "id": 654, "name": "Saint Helena, Ascension and Tristan da Cunha", "a2": "sh" },
    { "id": 659, "name": "Saint Kitts and Nevis", "a2": "kn" },
    { "id": 662, "name": "Saint Lucia", "a2": "lc" },
    { "id": 663, "name": "Saint Martin (French part)", "a2": "mf" },
    { "id": 666, "name": "Saint Pierre and Miquelon", "a2": "pm" },
    { "id": 670, "name": "Saint Vincent and the Grenadines", "a2": "vc" },
    { "id": 882, "name": "Samoa", "a2": "ws" },
    { "id": 674, "name": "San Marino", "a2": "sm" },
    { "id": 678, "name": "Sao Tome and Principe", "a2": "st" },
    { "id": 682, "name": "Saudi Arabia", "a2": "sa" },
    { "id": 686, "name": "Senegal", "a2": "sn" },
    { "id": 688, "name": "Serbia", "a2": "rs" },
    { "id": 690, "name": "Seychelles", "a2": "sc" },
    { "id": 694, "name": "Sierra Leone", "a2": "sl" },
    { "id": 702, "name": "Singapore", "a2": "sg" },
    { "id": 534, "name": "Sint Maarten (Dutch part)", "a2": "sx" },
    { "id": 703, "name": "Slovakia", "a2": "sk" },
    { "id": 705, "name": "Slovenia", "a2": "si" },
    { "id": 90, "name": "Solomon Islands", "a2": "sb" },
    { "id": 706, "name": "Somalia", "a2": "so" },
    { "id": 710, "name": "South Africa", "a2": "za" },
    { "id": 239, "name": "South Georgia and the South Sandwich Islands", "a2": "gs" },
    { "id": 728, "name": "South Sudan", "a2": "ss" },
    { "id": 724, "name": "Spain", "a2": "es" },
    { "id": 144, "name": "Sri Lanka", "a2": "lk" },
    { "id": 729, "name": "Sudan", "a2": "sd" },
    { "id": 740, "name": "Suriname", "a2": "sr" },
    { "id": 744, "name": "Svalbard and Jan Mayen", "a2": "sj" },
    { "id": 752, "name": "Sweden", "a2": "se" },
    { "id": 756, "name": "Switzerland", "a2": "ch" },
    { "id": 760, "name": "Syrian Arab Republic", "a2": "sy" },
    { "id": 158, "name": "Taiwan", "a2": "tw" },
    { "id": 762, "name": "Tajikistan", "a2": "tj" },
    { "id": 834, "name": "Tanzania, United Republic of", "a2": "tz" },
    { "id": 764, "name": "Thailand", "a2": "th" },
    { "id": 626, "name": "Timor-Leste", "a2": "tl" },
    { "id": 768, "name": "Togo", "a2": "tg" },
    { "id": 772, "name": "Tokelau", "a2": "tk" },
    { "id": 776, "name": "Tonga", "a2": "to" },
    { "id": 780, "name": "Trinidad and Tobago", "a2": "tt" },
    { "id": 788, "name": "Tunisia", "a2": "tn" },
    { "id": 792, "name": "Turkey", "a2": "tr" },
    { "id": 795, "name": "Turkmenistan", "a2": "tm" },
    { "id": 796, "name": "Turks and Caicos", "a2": "tc" },
    { "id": 798, "name": "Tuvalu", "a2": "tv" },
    { "id": 800, "name": "Uganda", "a2": "ug" },
    { "id": 804, "name": "Ukraine", "a2": "ua" },
    { "id": 784, "name": "United Arab Emirates", "a2": "ae" },
    { "id": 826, "name": "United Kingdom", "a2": "gb" },
    { "id": 840, "name": "United States", "a2": "us" },
    { "id": 581, "name": "United States Minor Outlying Islands", "a2": "um" },
    { "id": 858, "name": "Uruguay", "a2": "uy" },
    { "id": 860, "name": "Uzbekistan", "a2": "uz" },
    { "id": 548, "name": "Vanuatu", "a2": "vu" },
    { "id": 862, "name": "Venezuela (Bolivarian Republic of)", "a2": "ve" },
    { "id": 704, "name": "Viet Nam", "a2": "vn" },
    { "id": 92, "name": "Virgin Islands (British)", "a2": "vg" },
    { "id": 850, "name": "Virgin Islands (U.S.)", "a2": "vi" },
    { "id": 876, "name": "Wallis and Futuna", "a2": "wf" },
    { "id": 732, "name": "Western Sahara", "a2": "eh" },
    { "id": 887, "name": "Yemen", "a2": "ye" },
    { "id": 894, "name": "Zambia", "a2": "zm" },
    { "id": 716, "name": "Zimbabwe", "a2": "zw" }
  ]
}
